<div
  ngFileDrop
  class="drop-area position-relative"
  ngFileDrop
  [options]="options"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploadInput"
  [ngClass]="{ 'is-drop-over': dragOver }"
>
  <h6>{{ 'actions.dragAndDropFile' | translate }}</h6>
  <h6>{{ 'nouns.or' | translate }}</h6>
  <!-- TODO: change for web component upload button -->
  <div class="file-field input-field padding">
    <div class="btn btn--secondary">
      <span>{{ 'actions.selectFileUpload' | translate }}</span>
      <input
        type="file"
        ngFileSelect
        [options]="options"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput"
      />
    </div>
    <div class="file-path-wrapper">
      <input class="file-path validate" type="text" />
    </div>
  </div>
  <div *ngIf="showSpinner" class="preloader-wrapper small active spinner-centered">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div>
      <div class="gap-patch">
        <div class="circle"></div>
      </div>
      <div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>
